import Validator from './Validator'

class COMvalidator extends Validator {
  optionalPrefix = 'D'
}

export default COMvalidator
